import Vue from 'vue';
import {IsPC} from "@/utils/resize";

import { Message } from 'element-ui'

let isPC = IsPC();

const msg = {
	// msgSuccess(msg) {
	// 	return Message({
	// 		message: msg,
	// 		type: 'success'
	// 	})
	// },
	// msgError(msg) {
	// 	return Message.error(msg)
	// },
	// msgWarning(msg) {
	// 	return Message({
	// 		message: msg,
	// 		type: 'warning'
	// 	})
	// },
	// msgInfo(msg) {
	// 	return Message(msg)
	// }
}

// Vue.prototype.$modal = msg;

export default msg
